import React, { Component, Fragment } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import AppURL from '../../api/AppURL';
import axios from 'axios'
import { Link } from 'react-router-dom';
import CategoryLoading from '../PlaceHolder/CategoryLoading';

class Categories extends Component {
     constructor() {
          super();
          this.state = {
               MenuData: [],
               isLoading: "",
               mainDiv: "d-none"
          }
     }

     componentDidMount() {
          axios.get(AppURL.AllCategoryDetails).then(response => {
               this.setState({
                    MenuData: response.data, isLoading: "d-none",
                    mainDiv: " "
               });

          }).catch(error => {

          });
     }


     render() {

          const CatList = this.state.MenuData;
          const MyView = CatList.map((CatList, i) => {
               // return <Col key={i.toString()} className="p-0" key={1} xl={2} lg={2} md={2} sm={6} xs={6}>
               return <Col key={i.toString()} className="p-0" xl={2} lg={2} md={2} sm={6} xs={6}>


                    {/* <Link to={"/productcategory/" + CatList.category_name}> লিংকটি ব্যবহার করে, category_name এর মান অনুযায়ী URL তৈরি করা হচ্ছে।
                    যদি CatList.category_name এর মান "electronics" হয়, তাহলে লিংকটি /productcategory/electronics হবে,
                    এই লিংকটি ক্লিক করলে React Router URL-টি /productcategory/electronics এর মতো রাউটে পাঠায়, যা <Route exact path="/productcategory/:category" element={ProductCategoryPage} /> 
                    রাউটারের সাথে মিল খুঁজে ProductCategoryPage কম্পোনেন্টকে লোড করবে।
                    AppRoute.js এ আপনি একটি রাউট <Route exact path="/productcategory/:category" element={ProductCategoryPage} /> তৈরি করেছেন যা /productcategory/:category পাথের জন্য ProductCategoryPage কম্পোনেন্ট লোড করবে।
                    :category অংশটি একটি ডায়নামিক প্যারামিটার, যা রাউটারের জন্য URL-এর ডায়নামিক অংশ হিসেবে কাজ করে এবং এটি যে কোনো ক্যাটাগরি নাম ধারণ করতে পারে। উদাহরণস্বরূপ:
                    যদি URL হয় /productcategory/electronics, তাহলে category প্যারামিটারটি "electronics" হিসেবে ধরা হবে।
                    যদি URL হয় /productcategory/fashion, তাহলে category প্যারামিটারটি "fashion" হিসেবে ধরা হবে।
                    ProductCategoryPage কম্পোনেন্টের match.params.category এর মাধ্যমে এই category প্যারামিটারটি অ্যাক্সেসযোগ্য হবে।
                    */}


                    <Link className="text-link" to={"/productcategory/" + CatList.category_name}>
                         <Card className="h-100 w-100 text-center">
                              <Card.Body>
                                   <img className="center" src={CatList.category_image} />
                                   <h5 className="category-name">{CatList.category_name}</h5>
                              </Card.Body>
                         </Card>
                    </Link>
               </Col>
          })


          return (
               <Fragment>
                    <CategoryLoading isLoading={this.state.isLoading} />

                    <div className={this.state.mainDiv}>
                         <Container className="text-center" fluid={true}>
                              <div className="section-title text-center mb-55"><h2> CATEGORIES</h2>
                                   <p>Some Of Our Exclusive Collection, You May Like</p>
                              </div>

                              <Row>
                                   {MyView}
                              </Row>


                         </Container>
                    </div>
               </Fragment>
               // <Fragment>

               //      <Container className="text-center" fluid={true}>
               //           <div className="section-title text-center mb-55"><h2> CATEGORIES</h2>
               //                <p>Some Of Our Exclusive Collection, You May Like</p>
               //           </div>

               //           <Row>


               //                <Col key={1} xl={6} lg={6} md={2} sm={12} xs={12}>
               //                     <Row>
               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/f15c02bfeb02d15d.png?q=100" />
               //                                         <h5 className="category-name">Top Offers</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>

               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/29327f40e9c4d26b.png?q=100" />
               //                                         <h5 className="category-name">Grocery</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/22fddf3c7da4c4f4.png?q=100" />
               //                                         <h5 className="category-name">Mobiles</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/82b3ca5fb2301045.png?q=100" />
               //                                         <h5 className="category-name">Fashion</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>
               //                     </Row>

               //                </Col>



               //                <Col key={1} xl={6} lg={6} md={2} sm={12} xs={12}>
               //                     <Row>
               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/69c6589653afdb9a.png?q=100" />
               //                                         <h5 className="category-name">Electronics</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>

               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/ab7e2b022a4587dd.jpg?q=100" />
               //                                         <h5 className="category-name">Home</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/0ff199d1bd27eb98.png?q=100" />
               //                                         <h5 className="category-name">Appliances</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/dff3f7adcf3a90c6.png?q=100" />
               //                                         <h5 className="category-name">Beauty</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>
               //                     </Row>

               //                </Col>
               //           </Row>




               //           <Row>


               //                <Col key={1} xl={6} lg={6} md={2} sm={12} xs={12}>
               //                     <Row>
               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/f15c02bfeb02d15d.png?q=100" />
               //                                         <h5 className="category-name">Top Offers</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>

               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/29327f40e9c4d26b.png?q=100" />
               //                                         <h5 className="category-name">Grocery</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/22fddf3c7da4c4f4.png?q=100" />
               //                                         <h5 className="category-name">Mobiles</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/82b3ca5fb2301045.png?q=100" />
               //                                         <h5 className="category-name">Fashion</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>
               //                     </Row>

               //                </Col>



               //                <Col key={1} xl={6} lg={6} md={2} sm={12} xs={12}>
               //                     <Row>
               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/69c6589653afdb9a.png?q=100" />
               //                                         <h5 className="category-name">Electronics</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>

               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/ab7e2b022a4587dd.jpg?q=100" />
               //                                         <h5 className="category-name">Home</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/0ff199d1bd27eb98.png?q=100" />
               //                                         <h5 className="category-name">Appliances</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>


               //                          <Col className="p-0" key={1} xl={3} lg={3} md={3} sm={6} xs={6}>
               //                               <Card className="h-100 w-100 text-center">
               //                                    <Card.Body>
               //                                         <img className="center" src="https://rukminim1.flixcart.com/flap/128/128/image/dff3f7adcf3a90c6.png?q=100" />
               //                                         <h5 className="category-name">Beauty</h5>
               //                                    </Card.Body>
               //                               </Card>
               //                          </Col>
               //                     </Row>

               //                </Col>
               //           </Row>


               //      </Container>

               // </Fragment>
          )
     }
}

export default Categories
